export const TOKEN_KEY = 'jwtt';

export const LEASING_PARTNER = 'leasing_partner';
export const STO_TOKEN_KEY = 'sto_vote_token';
export const STO_COOKIE_MAX_AGE_DAYS = 60;
export const COOKIES_LOCATION = 'current_location';



// WEBPACK FOOTER //
// ./src/shared/constants/cookies.js